import {STORE_PROPERTY_REQUEST, STORE_PROPERTY_SUCCESS, STORE_PROPERTY_FAILURE} from '../actions';
import {RETIRE_PROPERTY_REQUEST, RETIRE_PROPERTY_SUCCESS, RETIRE_PROPERTY_FAILURE} from '../actions';
import {UPDATE_PROPERTY_REQUEST, UPDATE_PROPERTY_SUCCESS, UPDATE_PROPERTY_FAILURE} from '../actions';
import {
    PROPERTY_DOCUMENT_UPLOAD_REQUEST,
    PROPERTY_DOCUMENT_UPLOAD_SUCCESS,
    PROPERTY_DOCUMENT_UPLOAD_FAILURE,
    PROPERTY_DOCUMENT_DELETE_REQUEST,
    PROPERTY_DOCUMENT_DELETE_SUCCESS,
    PROPERTY_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const PROPERTY_INITIAL_STATE = {
    id: null,
    isFetching: false,
    isUploading: false,
    isRemoving: false,
    uploadError: null,
    removeError: null,
    documents: [],
    isRetired: false,
    error: null,
    registration_no: '',
    title: '',
    first_name: '',
    surname: '',
    house_no: '',
    street: '',
    district: '',
    city: '',
    county: '',
    postcode: '',
    phone_no: '',
    email: '',
    certificate_next_due: '',
    service_next_due: '',
    visit_booked: '',
    last_visit: '',
    visit_reason: '',
    latitude: '',
    longitude: ''
};

const propertyReducers = {
    [STORE_PROPERTY_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_PROPERTY_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [STORE_PROPERTY_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_PROPERTY_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_PROPERTY_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_PROPERTY_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [RETIRE_PROPERTY_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [RETIRE_PROPERTY_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null, isRetired: true}
    },
    [RETIRE_PROPERTY_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [PROPERTY_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [PROPERTY_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isUploading: false, uploadError: null};
    },
    [PROPERTY_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [PROPERTY_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [PROPERTY_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);

        return {...state, documents, isRemoving: false, removeError: null}
    },
    [PROPERTY_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function property(state = PROPERTY_INITIAL_STATE, action) {
    let reducer = propertyReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/property.js